import { render, staticRenderFns } from "./SearchDeal.vue?vue&type=template&id=4865b8f8&"
import script from "./SearchDeal.vue?vue&type=script&lang=js&"
export * from "./SearchDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports